import { render, staticRenderFns } from "./ExaminResult.vue?vue&type=template&id=4564d0f9&scoped=true&"
import script from "./ExaminResult.vue?vue&type=script&lang=js&"
export * from "./ExaminResult.vue?vue&type=script&lang=js&"
import style0 from "./ExaminResult.vue?vue&type=style&index=0&id=4564d0f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564d0f9",
  null
  
)

export default component.exports